var _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_44_4277",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3.98793H22.4725V23.4889H2V3.98793Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_44_4277)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.82371 13.111C5.22571 17.473 10.7647 21 12.2367 21.873C13.7137 20.991 19.2927 17.425 20.6497 13.115C21.5407 10.329 20.7137 6.80003 17.4277 5.74103C15.8357 5.23003 13.9787 5.54103 12.6967 6.53303C12.4287 6.73903 12.0567 6.74303 11.7867 6.53903C10.4287 5.51803 8.65471 5.21903 7.03771 5.74103C3.75671 6.79903 2.93271 10.328 3.82371 13.111ZM12.2377 23.489C12.1137 23.489 11.9907 23.459 11.8787 23.398C11.5657 23.227 4.19271 19.163 2.39571 13.569C2.39471 13.569 2.39471 13.568 2.39471 13.568C1.26671 10.046 2.52271 5.62003 6.57771 4.31303C8.48171 3.69703 10.5567 3.96803 12.2347 5.02703C13.8607 3.99903 16.0207 3.71503 17.8867 4.31303C21.9457 5.62203 23.2057 10.047 22.0787 13.568C20.3397 19.098 12.9127 23.223 12.5977 23.396C12.4857 23.458 12.3617 23.489 12.2377 23.489Z",
    fill: "url(#paint0_linear_44_4277)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1537 11.6129C17.7667 11.6129 17.4387 11.3159 17.4067 10.9239C17.3407 10.1019 16.7907 9.40793 16.0077 9.15493C15.6127 9.02693 15.3967 8.60393 15.5237 8.21093C15.6527 7.81693 16.0717 7.60293 16.4677 7.72693C17.8307 8.16793 18.7857 9.37493 18.9027 10.8019C18.9357 11.2149 18.6287 11.5769 18.2157 11.6099C18.1947 11.6119 18.1747 11.6129 18.1537 11.6129Z",
    fill: "url(#paint1_linear_44_4277)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_4277",
    x1: 12.2361,
    y1: 3.98792,
    x2: 8.47607,
    y2: 21.3562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E68FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6691FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_44_4277",
    x1: 17.1962,
    y1: 7.69177,
    x2: 16.3036,
    y2: 11.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E68FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6691FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartSvg);
export default __webpack_public_path__ + "static/media/HeartSVG.71251104f46d9299f6c996b07450f9fb.svg";
export { ForwardRef as ReactComponent };